import { TableCell } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { Filters, HeaderIcons } from 'components/infinitescrollvirtuoso/InfiniteScrollVirtuoso';
import { Dispatch, SetStateAction } from 'react';
import { ColumnData } from 'utils/util';

type Props<T> = {
    column: ColumnData<T>;
    sx?: SxProps<Theme>;
    filters: Filters;
    setFilters: Dispatch<SetStateAction<Filters>>;
};

const SEM_NEGRITO = { '& .MuiBox-root': { fontWeight: 400 } };

const CabecalhoColunaFiltravel = <T extends object>({ column, sx, filters, setFilters }: Props<T>) => (
    <TableCell
        align={column.textAlign}
        sx={[SEM_NEGRITO, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
    >
        <HeaderIcons column={column} filterOpt={{ filters, setFilters }} />
    </TableCell>
);

export default CabecalhoColunaFiltravel;
